<template>
  <div>
    <app-header title="KZ Internal Tools" />
    <!-- <div class="jumbotron">
      <div class="container">
        <h1>KZ Internal Tools</h1>
      </div>
    </div> -->
    <b-container>
      <ul>
        <li v-for="service in auth.services" :key="service.name" v-router-link="{name:service.name}">
          {{ service.meta.displayName }}
        </li>
      </ul>
      <p v-if="auth.services.length == 0">
        {{ auth.user.email }} does not have access to any Kaizen services.
      </p>
    </b-container>
  </div>
</template>

<script>
import $auth from '@/services/auth'; // eslint-disable-line import/no-cycle
import AppHeader from '@/components/AppHeader';

export default {
  name: 'Home',

  components: {
    AppHeader,
  },

  data() {
    return {
      auth: $auth,
    };
  },
};
</script>
